// Central API configuration
// Use REACT_APP_API_BASE set in Pages environment or fall back to empty string
// Use typeof check so this file is safe to import in browser (where `process` may be undefined)
const API_BASE = "https://korime_v4.ejemadl61.workers.dev";

function apiUrl(path) {
  // ensure leading slash
  if (!path) return API_BASE;
  if (path.startsWith("/")) return `${API_BASE}${path}`;
  return `${API_BASE}/${path}`;
}

export { API_BASE, apiUrl };
